/**
 * @module constants
 */

export const keys = {
    TAB: 9,
    ENTER: 13,
    LEFTARROW: 37,
    UPARROW: 38,
    RIGHTARROW: 39,
    DOWNARROW: 40,
    ESCAPE: 27
};
